export default {
  club_name: 'Onsala BK',
  club_name_short: 'onsalabk',
  stadium_name: '',
  staging_url: 'https://onsalabk.api.fangroup.io',
  prod_url: 'https://onsalabk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/onsalabk',
  club_logo: '/assets/teams/onsalabk.png',
  app_name: 'onsalabk',
  websale_name: 'onsalabk',
  ntb_team_id: 10051,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'onsalabk',
  monolithEnabled: false,
};
